// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1sY45","ripple":"Loader_ripple__2iaVu"};